<div [ngClass]="handleClass(active)">
  <div
    class="badge-left"
    [ngClass]="{
      'no-count': !showFilterCount,
      'no-icon': !showIcon
    }">
    @if (showIcon) {
      <img
        src="{{ src }}"
        class="badge-icon"
        matTooltipPosition="above"
        mat-raised-button
        matTooltip="{title}"
        matTooltipClass="customToolTip"
        [style]="{
          width: '1.3rem',
          filter: active ? 'brightness(0) invert(1)' : ''
        }" />
    }
    @if (showFilterCount) {
      <span class="alert-count">{{ count }}</span>
    }
  </div>
  <div class="badge-right">
    <span class="alert-title uppercase">{{
      title | levelsStateTranslate
    }}</span>
  </div>
</div>
